import baseRequest from "../_core/baseRequest";

export default {
    click2Call: params => baseRequest.post(`/call/click2call`, params),
    checkCallStatus: callRecordId => baseRequest.get(`/call/status/${callRecordId}`),
}; 